var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"byte"},_vm._l((_vm.byte),function(bit){return _c('div',{staticClass:"bit"},[_vm._v(_vm._s(bit))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }